@file:Suppress("ktlint:standard:backing-property-naming")

package com.nonopn.icons

import androidx.compose.material.icons.Icons
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

public val Icons.Rounded.Certificate: ImageVector
    get() {
        if (_certificate != null) {
            return _certificate!!
        }
        _certificate =
            Builder(
                name = "Certificate",
                defaultWidth = 512.0.dp,
                defaultHeight = 512.0.dp,
                viewportWidth = 512.0f,
                viewportHeight = 512.0f,
            )
                .apply {
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(141.0f, 111.0f)
                        horizontalLineToRelative(170.0f)
                        curveToRelative(5.52f, 0.0f, 10.0f, -4.48f, 10.0f, -10.0f)
                        reflectiveCurveToRelative(-4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineTo(141.0f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        reflectiveCurveTo(135.48f, 111.0f, 141.0f, 111.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(141.0f, 161.0f)
                        horizontalLineToRelative(170.0f)
                        curveToRelative(5.52f, 0.0f, 10.0f, -4.48f, 10.0f, -10.0f)
                        reflectiveCurveToRelative(-4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineTo(141.0f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        reflectiveCurveTo(135.48f, 161.0f, 141.0f, 161.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(141.0f, 211.0f)
                        horizontalLineToRelative(170.0f)
                        curveToRelative(5.52f, 0.0f, 10.0f, -4.48f, 10.0f, -10.0f)
                        reflectiveCurveToRelative(-4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineTo(141.0f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        reflectiveCurveTo(135.48f, 211.0f, 141.0f, 211.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(141.0f, 381.0f)
                        horizontalLineToRelative(60.0f)
                        curveToRelative(5.52f, 0.0f, 10.0f, -4.48f, 10.0f, -10.0f)
                        reflectiveCurveToRelative(-4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineToRelative(-60.0f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        reflectiveCurveTo(135.48f, 381.0f, 141.0f, 381.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(381.0f, 261.0f)
                        curveToRelative(-27.57f, 0.0f, -50.0f, 22.43f, -50.0f, 50.0f)
                        reflectiveCurveToRelative(22.43f, 50.0f, 50.0f, 50.0f)
                        reflectiveCurveToRelative(50.0f, -22.43f, 50.0f, -50.0f)
                        reflectiveCurveTo(408.57f, 261.0f, 381.0f, 261.0f)
                        close()
                        moveTo(381.0f, 341.0f)
                        curveToRelative(-16.54f, 0.0f, -30.0f, -13.46f, -30.0f, -30.0f)
                        reflectiveCurveToRelative(13.46f, -30.0f, 30.0f, -30.0f)
                        reflectiveCurveToRelative(30.0f, 13.46f, 30.0f, 30.0f)
                        reflectiveCurveTo(397.54f, 341.0f, 381.0f, 341.0f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(471.0f, 311.0f)
                        curveToRelative(0.0f, -39.11f, -25.08f, -72.47f, -60.0f, -84.85f)
                        verticalLineTo(11.0f)
                        curveToRelative(0.0f, -5.52f, -4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineTo(51.0f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        verticalLineToRelative(450.0f)
                        curveToRelative(0.0f, 5.52f, 4.48f, 10.0f, 10.0f, 10.0f)
                        horizontalLineToRelative(185.17f)
                        curveToRelative(5.52f, 0.0f, 10.0f, -4.48f, 10.0f, -10.0f)
                        reflectiveCurveToRelative(-4.48f, -10.0f, -10.0f, -10.0f)
                        horizontalLineTo(61.0f)
                        verticalLineTo(21.0f)
                        horizontalLineToRelative(330.0f)
                        verticalLineToRelative(200.56f)
                        curveToRelative(-6.49f, -0.72f, -13.09f, -0.77f, -20.0f, 0.0f)
                        verticalLineTo(81.0f)
                        curveToRelative(0.0f, -2.65f, -1.05f, -5.2f, -2.93f, -7.07f)
                        lineToRelative(-30.0f, -30.0f)
                        curveTo(336.2f, 42.05f, 333.65f, 41.0f, 331.0f, 41.0f)
                        horizontalLineTo(121.0f)
                        curveToRelative(-2.65f, 0.0f, -5.2f, 1.05f, -7.07f, 2.93f)
                        lineToRelative(-30.0f, 30.0f)
                        curveTo(82.05f, 75.8f, 81.0f, 78.35f, 81.0f, 81.0f)
                        verticalLineToRelative(67.67f)
                        curveToRelative(0.0f, 5.52f, 4.48f, 10.0f, 10.0f, 10.0f)
                        reflectiveCurveToRelative(10.0f, -4.48f, 10.0f, -10.0f)
                        verticalLineTo(85.14f)
                        lineTo(125.14f, 61.0f)
                        horizontalLineToRelative(201.71f)
                        lineTo(351.0f, 85.14f)
                        verticalLineToRelative(140.98f)
                        curveToRelative(-35.83f, 12.62f, -60.0f, 46.6f, -60.0f, 84.88f)
                        curveToRelative(0.0f, 25.7f, 10.82f, 49.94f, 30.0f, 67.07f)
                        verticalLineTo(411.0f)
                        horizontalLineTo(125.14f)
                        lineTo(101.0f, 386.86f)
                        verticalLineTo(188.67f)
                        curveToRelative(0.0f, -5.52f, -4.48f, -10.0f, -10.0f, -10.0f)
                        reflectiveCurveToRelative(-10.0f, 4.48f, -10.0f, 10.0f)
                        verticalLineTo(391.0f)
                        curveToRelative(0.0f, 2.65f, 1.05f, 5.2f, 2.93f, 7.07f)
                        lineToRelative(30.0f, 30.0f)
                        curveToRelative(1.88f, 1.88f, 4.42f, 2.93f, 7.07f, 2.93f)
                        horizontalLineToRelative(200.0f)
                        verticalLineToRelative(20.0f)
                        horizontalLineToRelative(-44.83f)
                        curveToRelative(-5.52f, 0.0f, -10.0f, 4.48f, -10.0f, 10.0f)
                        reflectiveCurveToRelative(4.48f, 10.0f, 10.0f, 10.0f)
                        horizontalLineTo(321.0f)
                        verticalLineToRelative(30.0f)
                        curveToRelative(0.0f, 3.6f, 1.94f, 6.93f, 5.07f, 8.7f)
                        curveToRelative(3.13f, 1.77f, 6.98f, 1.73f, 10.07f, -0.13f)
                        lineTo(381.0f, 482.66f)
                        lineToRelative(44.85f, 26.91f)
                        curveToRelative(3.09f, 1.85f, 6.94f, 1.9f, 10.07f, 0.13f)
                        curveToRelative(3.14f, -1.77f, 5.07f, -5.1f, 5.07f, -8.7f)
                        verticalLineToRelative(-43.2f)
                        curveToRelative(0.0f, -5.52f, -4.48f, -10.0f, -10.0f, -10.0f)
                        reflectiveCurveToRelative(-10.0f, 4.48f, -10.0f, 10.0f)
                        verticalLineToRelative(25.54f)
                        lineToRelative(-34.85f, -20.91f)
                        curveToRelative(-3.17f, -1.9f, -7.12f, -1.9f, -10.29f, 0.0f)
                        lineTo(341.0f, 483.34f)
                        curveToRelative(0.0f, -10.47f, 0.0f, -81.04f, 0.0f, -91.73f)
                        curveToRelative(25.15f, 12.53f, 54.85f, 12.53f, 80.0f, 0.0f)
                        verticalLineTo(417.8f)
                        curveToRelative(0.0f, 5.52f, 4.48f, 10.0f, 10.0f, 10.0f)
                        reflectiveCurveToRelative(10.0f, -4.48f, 10.0f, -10.0f)
                        verticalLineToRelative(-39.78f)
                        curveTo(459.4f, 361.53f, 471.0f, 337.6f, 471.0f, 311.0f)
                        close()
                        moveTo(311.0f, 311.0f)
                        curveToRelative(0.0f, -38.56f, 31.37f, -70.0f, 70.0f, -70.0f)
                        curveToRelative(38.6f, 0.0f, 70.0f, 31.4f, 70.0f, 70.0f)
                        reflectiveCurveToRelative(-31.4f, 70.0f, -70.0f, 70.0f)
                        curveTo(342.33f, 381.0f, 311.0f, 349.51f, 311.0f, 311.0f)
                        close()
                    }
                }
                .build()
        return _certificate!!
    }

private var _certificate: ImageVector? = null
